import React from 'react';
import { Descriptions, Tag, Space } from 'antd';
import s from '../../s.module.less';

interface IPropertiesPanelProps {
    node: any;
    questions: any[];
    onConfigChange?: (nodeId: string, config: any) => void;
}

const PropertiesPanel: React.FC<IPropertiesPanelProps> = ({
    node,
    questions,
    onConfigChange,
}) => {
    const getQuestionTitle = (questionId?: string) => {
        if (!questionId) return 'Not selected';
        const question = questions.find(q => q.id === questionId);
        return question?.title || 'Unknown question';
    };

    const getResultTypeLabel = (resultType?: string) => {
        switch (resultType) {
            case 'not_suitable':
                return <Tag color="red">Not Suitable</Tag>;
            case 'text_visit':
                return <Tag color="blue">Text Visit</Tag>;
            case 'continue':
                return <Tag color="green">Continue</Tag>;
            case 'add_note':
                return <Tag color="orange">Add Note</Tag>;
            default:
                return <Tag>Unknown</Tag>;
        }
    };

    const getTriggerTimingLabel = (timing?: string) => {
        switch (timing) {
            case 'immediate':
                return <Tag color="blue">Immediate</Tag>;
            case 'after_last_question':
                return <Tag color="green">After Last Question</Tag>;
            default:
                return <Tag>Not set</Tag>;
        }
    };

    return (
        <div className={s.propertiesPanel}>
            <Descriptions
                column={1}
                size="small"
                bordered
            >
                <Descriptions.Item label="Node Type">
                    <Tag color="blue">{node.type}</Tag>
                </Descriptions.Item>
                
                <Descriptions.Item label="Node ID">
                    {node.id}
                </Descriptions.Item>

                {node.type === 'question' && (
                    <>
                        <Descriptions.Item label="Question">
                            {getQuestionTitle(node.data?.questionId)}
                        </Descriptions.Item>
                        <Descriptions.Item label="Answer Condition">
                            {node.data?.answerCondition || 'Not set'}
                        </Descriptions.Item>
                    </>
                )}

                {node.type === 'result' && (
                    <>
                        <Descriptions.Item label="Result Type">
                            {getResultTypeLabel(node.data?.resultType)}
                        </Descriptions.Item>
                        {node.data?.skipToQuestionId && (
                            <Descriptions.Item label="Skip to Question">
                                {getQuestionTitle(node.data.skipToQuestionId)}
                            </Descriptions.Item>
                        )}
                        {node.data?.selectedOptions && node.data.selectedOptions.length > 0 && (
                            <Descriptions.Item label="Selected Options">
                                <Space wrap>
                                    {node.data.selectedOptions.map((option: string) => (
                                        <Tag key={option}>{option}</Tag>
                                    ))}
                                </Space>
                            </Descriptions.Item>
                        )}
                        {node.data?.customText && (
                            <Descriptions.Item label="Custom Text">
                                {node.data.customText}
                            </Descriptions.Item>
                        )}
                    </>
                )}

                {node.type === 'jump' && (
                    <Descriptions.Item label="Target Question">
                        {getQuestionTitle(node.data?.targetQuestionId)}
                    </Descriptions.Item>
                )}

                <Descriptions.Item label="Trigger Timing">
                    {getTriggerTimingLabel(node.data?.triggerTiming)}
                </Descriptions.Item>

                <Descriptions.Item label="Position">
                    X: {Math.round(node.position?.x || 0)}, Y: {Math.round(node.position?.y || 0)}
                </Descriptions.Item>
            </Descriptions>
        </div>
    );
};

export default PropertiesPanel;
